import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '@shared/components/utils/hoc/withAnimation';

const ChannelListInfoContainer = styled.div<{ focused?: boolean }>`
  position: absolute;
  bottom: ${-1042 * Screen.widthRatio}px;
  left: ${520 * Screen.widthRatio}px;
  width: ${(props) => (props.focused ? 1180 : 1050) * Screen.widthRatio}px;
`;

export default withAnimation(ChannelListInfoContainer);
